import { useEffect } from 'react';
import { useLayout } from '../context/LayoutContext';

export enum LoaderId {
  homePage = 'homePage',
}

export const useShowLoader = (id: LoaderId, ...args: any[]): void => {
  const { showLoader, hideLoader } = useLayout();

  useEffect(() => {
    if ([...args].find((arg) => !!arg)) {
      showLoader(id);
    } else {
      hideLoader(id);
    }
  }, [...args]);
};
